import classNames from "classnames";
import React, { useContext } from "react";
import { ConfigContext } from "../config-provider";
export interface DividerProps {
  type?: string;
}
const Divider: React.FC<DividerProps> = props => {
  const { type } = props;
  const { getPrefixCls } = useContext(ConfigContext);
  const prefixCls = getPrefixCls("divider");
  const classString = classNames(prefixCls, `${prefixCls}-${type}`);
  return <div className={classString}>红色文字测试</div>;
};
export default Divider;
